import { Button } from "../../../ui/components/ui/button";
import { getIcon } from "../icon-map";
import { getReadableTextColor } from "./v2-helpers";

export function JobPostsV2Header({
  brandColor,
  organizationName,
  logoUrl,
  onApplyClick,
}: {
  brandColor: string;
  organizationName: string;
  logoUrl?: string;
  onApplyClick: () => void;
}) {
  const SendIcon = getIcon("send");

  return (
    <div className="embed-job-header sticky top-0 z-50 border-b border-gray-200 bg-white/90 backdrop-blur">
      <div className="mx-auto max-w-6xl px-4 py-3 flex items-center gap-3">
        <div className="flex items-center gap-3 min-w-0">
          {logoUrl ? (
            <img src={logoUrl} alt="" className="h-10 w-10 rounded object-contain bg-white" />
          ) : (
            <div className="h-10 w-10 rounded bg-gray-200" />
          )}
          <div className="min-w-0">
            <div className="text-xs font-semibold tracking-wide truncate" style={{ color: brandColor }}>
              {organizationName}
            </div>
          </div>
        </div>

        <div className="ml-auto flex items-center gap-3">
          <Button
            type="button"
            variant="ghost"
            className="embed-job-header-cta rounded-full px-4 py-2 text-sm font-medium shadow-none hover:opacity-90 hover:bg-transparent gap-2"
            style={{ backgroundColor: brandColor, color: getReadableTextColor(brandColor) }}
            onClick={onApplyClick}
          >
            {SendIcon ? (
              <span className="[&>svg]:w-4 [&>svg]:h-4" aria-hidden="true">
                <SendIcon />
              </span>
            ) : null}
            Jetzt bewerben
          </Button>
        </div>
      </div>
    </div>
  );
}
